import { render, staticRenderFns } from "./DialogEditFolderSearch.vue?vue&type=template&id=3c51aa30&scoped=true"
import script from "./DialogEditFolderSearch.vue?vue&type=script&lang=js"
export * from "./DialogEditFolderSearch.vue?vue&type=script&lang=js"
import style0 from "./DialogEditFolderSearch.vue?vue&type=style&index=0&id=3c51aa30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c51aa30",
  null
  
)

export default component.exports